
<f-dialog
    v-model       = "show"
    :width        = "modernization ? 1100 : 450"
    :hide-actions = "false"
    :show-header  = "true"
    :title        = "$t('unit.tzb.budget.title')"
    :show-save    = "true"
    @store        = "onStore"
    @cancel       = "onCancel"
>
    <template v-slot:content>
        <v-row dense class="pt-3">
            <v-col>
                <f-enum-select
                    v-model       = "tzb.measure"
                    :label        = "$t('unit.tzb.budget.unit.measure')"
                    class         = "measure-type"
                    module        = "msd"
                    type          = "tzbUnitMeasure"
                    :hide-details = "true"
                />
            </v-col>
            <v-col>
                <div class="mb-2" v-if="!modernization">
                    <f-currency-field
                        :label        = "$t('unit.tzb.budget.unit.budget')"
                        v-model       = "tzb.costs"
                        class         = "money measure-costs"
                        :readonly     = "!unitMeasure"
                    />
                </div>
            </v-col>
            <v-col v-if="modernization">

            </v-col>
        </v-row>
        <v-row dense class="pt-1" v-if="!modernization">
            <v-col>
                <v-textarea
                    :label         = "$t('unit.tzb.budget.unit.comment')"
                    v-model        = "tzb.comment"
                    rows           = "4"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    hide-details   = "true"
                    no-resize
                />
            </v-col>
        </v-row>
        <v-row dense class="pt-3" v-if="modernization">
            <v-col>
                <p-site-tzb-calculation-component
                    :title  = "$t('unit.tzb.engine.title')"
                    :tzb-component = "tzb.engine"
                />
            </v-col>
            <v-col>
                <p-site-tzb-calculation-component
                    :title  = "$t('unit.tzb.automatic.title')"
                    :tzb-component = "tzb.automatic"
                />
            </v-col>
            <v-col>
                <p-site-tzb-calculation-component
                    :title  = "$t('unit.tzb.control.title')"
                    :tzb-component = "tzb.control"
                />
            </v-col>
        </v-row>
        <v-row dense class="pt-3" v-if="modernization">
            <v-col>
                <p-site-tzb-calculation-component
                    :title  = "$t('unit.tzb.manholeDoor.title')"
                    :tzb-component = "tzb.liftShaftDoor"
                />
            </v-col>
            <v-col>
                <p-site-tzb-calculation-component
                    :title  = "$t('unit.tzb.car.title')"
                    :tzb-component = "tzb.car"
                />
            </v-col>
            <v-col>
                <p-site-tzb-calculation-component
                    :title  = "$t('unit.tzb.speedLimiter.title')"
                    :tzb-component = "tzb.speedLimiter"
                />
            </v-col>
        </v-row>
        <v-row dense class="pt-3" v-if="modernization">
            <v-col>
                <p-site-tzb-calculation-component
                    :title  = "$t('unit.tzb.saftyCatch.title')"
                    :tzb-component = "tzb.saftyCatch"
                />
            </v-col>
            <v-col>
                <p-site-tzb-calculation-component
                    :title  = "$t('unit.tzb.doorDrive.title')"
                    :tzb-component = "tzb.doorDrive"
                />
            </v-col>
            <v-col>
                <p-site-tzb-calculation-component
                    :title  = "$t('unit.tzb.emcSystem.title')"
                    :tzb-component = "tzb.emcSystem"
                />
            </v-col>
        </v-row>
    </template>
</f-dialog>
